import * as at from "./types";

export const setBreadcrumbs = (nav) => (dispatch) => {
  dispatch({
    type: at.SET_BREADCRUMBS,
    payload: { nav: nav },
  });
};
